// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"3aa66f9b","704":"0c3565cf","811":"a218b8f4","876":"b1d95b61"}[chunkId] + ".js";
};